export const GET_STORIES_BY_COHORTS = "GET_STORIES_BY_COHORTS"
export const GET_STORIES_BY_COHORTS_REQUEST = "GET_STORIES_BY_COHORTS_REQUEST"
export const GET_STORIES_BY_COHORTS_SUCCESS = "GET_STORIES_BY_COHORTS_SUCCESS"
export const GET_STORIES_BY_COHORTS_ERROR = "GET_STORIES_BY_COHORTS_ERROR"
export const HIDE_STORIES = "HIDE_STORIES"
export const SHOW_STORIES = "SHOW_STORIES"
